export default __webpack_public_path__ + "static/media/Sumedh.92bad749.jpeg";